<div id="fn-checkbox-filter-container" class="dropdown" (click)="toggleSelect($event,true)">
    <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle filter_btn" ngDefaultControl
            (click)="toggleSelect($event,!showDropDown)" [(ngModel)]="selectedMap" data-toggle="dropdown"><span
              class="float-left text-truncate" [innerHtml]="description"></span>
        <i class="fn-global-filter fa-fw"></i>
    </button>
    @if (showDropDown) {
    <ul class="dropdown-menu left fn-checkbox-filter-list show fn-multi-drop-ul" [fnAppendTo]="appendTo"
        [isTopPositionOnly]="true" (outsideClick)="closeDropDown()" [isSetWidth]='false'>
        <li>
            <input type="text" placeholder="Search.." [(ngModel)]="searchInput" (keyup)="onSearch($event)" maxlength="40"
                   class="form-control input-rounded">
            <i class="fn-global-times-line red search_icon" (click)="refreshSearch()"></i>
        </li>
        <li>
            <div class="row m-0">
                <div class="col-6"><span class="blue cursor-pointer" (click)="selectAction(true)">Select all</span></div>
                <div class="col-6 text-right"><span class="red cursor-pointer" (click)="selectAction(false)">Clear</span></div>
            </div>
        </li>
        <li>
            <ul class="fn-checkbox-item-listing">
                @for (uiItem of uiFilterArray; track uiItem; let i = $index) {
                <li [value]="uiItem.id">
                    <div class="text-truncate" title="{{uiItem.description | fnTranslate }}" (click)="selectParent(uiItem)">
                        <span><i class="fn-global-check text-bold"
                               [ngClass]="{'green': uiItem.isSelected, 'light-gray' : !uiItem.isSelected}"></i></span>
                        {{uiItem.description | fnTranslate }}
                    </div>
                    @if (isGrouping) {
                    <div class="sub_role">
                        @for (childItem of uiItem.childArray; track childItem) {
                        <div class="sub_role_data" (click)="selectChildItem(childItem,uiItem.id)">
                            <span><i class="fn-global-check"
                                   [ngClass]="{'green': childItem.isSelected, 'light-gray' : !childItem.isSelected}"></i></span>
                            <span>{{childItem.description | fnTranslate}}</span>
                        </div>
                        }
                    </div>
                    }
                </li>
                }
            </ul>
        </li>
    </ul>
    }
</div>
